module.exports = __webpack_public_path__ + "media/images/star-f5a56836dc9b31f49fea71283f05fd1b.png";